<template>
  <div>
  </div>
</template>

<script>
import SearchService from '@/services/Search.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'SearchCategory',
  props: { cat: String },
  data: () => {
    return {
      categories: [],
      catID: null
    }
  },
  computed: {
    ...mapGetters({
      portalConfig: 'getPortalConfig'
    })
  },
  created () {
    this.queryRedirect()
  },
  methods: {
    async queryRedirect () {
      await SearchService.searchLink(this.portalConfig.portalName)
        .then((res) => {
          if (res.status === 200) {
            this.$set(this, 'categories', res.data.supportTypes)
          } else {
            this.$router.push({ path: '/' })
          }
        })
      this.categories.forEach(element => {
        if (this.cat.toLowerCase().replace(/\s+/g, '') === element.tagName.toLowerCase().replace(/\s+/g, '')) {
          this.catID = element.id
        }
      })
      if (this.catID) {
        const searchterms = {
          supporttype: 'Organisation',
          topic: this.catID,
          topicName: this.cat,
          distance: null,
          postcode: null,
          gender: null,
          agegroup: null,
          viewpoint: null,
          terms: [],
          tagterms: [],
          referringPage: 'Main'
        }
        localStorage.setItem('searchTermsObject', JSON.stringify(searchterms))
        this.$router.push({ path: '/search' })
      } else {
        this.$router.push({ path: '/' })
      }
    }
  }
}
</script>
